import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';
export const initialState = {
    loading: false,
    message: '',
    list:null,
}
export const EarningStatementListAll = createAsyncThunk('type-valuation/list',async (data, { rejectWithValue }) => {
    try {
        const response = await masterService.getearningstatement (data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})
export const EarningStatementSlice = createSlice({
    name: 'EarningStatement',
    initialState,
    reducers: {
        EarningStatementListData: (state, action) => {
            state.loading = true
            state.list = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(EarningStatementListAll.pending, (state) => {
                state.loading = false
            })
            .addCase(EarningStatementListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})
export const {
    EarningStatementListData,
} = EarningStatementSlice.actions
export default EarningStatementSlice.reducer